import { FormEvent, useState } from 'react';

export default function ContactUs() {
  const [fullName, setFullName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  function handleSubmit(event: FormEvent) {
    event.preventDefault();
    const mailto = `mailto:info@harboursidechildren.ca?subject=Website%20Enquiry%20from%20${encodeURIComponent(
      fullName || 'Parent/Guardian'
    )}&body=${encodeURIComponent(
      `Name: ${fullName}\nEmail: ${email}\nPhone: ${phone}\n\nMessage:\n${message}`
    )}`;
    window.location.href = mailto;
  }

  return (
    <div className="min-h-screen bg-white">
      <section className="py-16 bg-gradient-to-br from-amber-50 to-yellow-100">
        <div className="max-w-6xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold text-dblue text-center mb-4">Contact Us</h1>
          <p className="text-gray-600 text-center max-w-2xl mx-auto">
            We’d love to hear from you. Send us a message and we’ll get back to you soon.
          </p>
        </div>
      </section>

      <section className="py-12">
        <div className="max-w-6xl mx-auto px-6 grid md:grid-cols-2 gap-10">
          <div>
            <div className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm">
              <h2 className="text-xl font-semibold text-dblue mb-4">Our Details</h2>
              <ul className="space-y-3 text-gray-700">
                <li>
                  <span className="font-medium">Address:</span> Suite 101 – 38 Fell Avenue, North Vancouver, BC
V7P 3S2
                </li>
                <li>
                  <span className="font-medium">Phone:</span> (604) 986-2389
                </li>
                <li>
                  <span className="font-medium">Email:</span> info@harboursidechildren.ca
                </li>
                <li className="text-sm text-gray-500">Office hours: Mon–Fri, 8:00am–5:00pm</li>
              </ul>
            </div>
          </div>

          <div>
            <form onSubmit={handleSubmit} className="bg-white border border-gray-200 rounded-lg p-6 shadow-sm space-y-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Full Name</label>
                <input
                  type="text"
                  required
                  value={fullName}
                  onChange={(e) => setFullName(e.target.value)}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-300"
                  placeholder="Your name"
                />
              </div>
              <div className="grid md:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email</label>
                  <input
                    type="email"
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-300"
                    placeholder="you@example.com"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone (optional)</label>
                  <input
                    type="tel"
                    value={phone}
                    onChange={(e) => setPhone(e.target.value)}
                    className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-300"
                    placeholder="(555) 123-4567"
                  />
                </div>
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">Message</label>
                <textarea
                  required
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  rows={6}
                  className="w-full border border-gray-300 rounded-md px-3 py-2 focus:outline-none focus:ring-2 focus:ring-amber-300"
                  placeholder="How can we help?"
                />
              </div>
              <div className="pt-2">
                <button
                  type="submit"
                  className="inline-flex items-center justify-center bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-md px-5 py-2.5 transition-colors"
                >
                  Send Message
                </button>
              </div>
            </form>
          </div>
        </div>
      </section>

      <section className="pb-16">
        <div className="max-w-6xl mx-auto px-6">
          <h2 className="text-xl font-semibold text-dblue mb-4">Find Us</h2>
          <div className="relative w-full" style={{ paddingBottom: '56.25%' }}>
            <iframe
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d6011.245994624553!2d-123.09552898052023!3d49.3156161509755!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x548671cb16e693bf%3A0xaf83b0d22ba50850!2sHarbourside%20Children&#39;s%20Centre!5e1!3m2!1sen!2sca!4v1755643258112!5m2!1sen!2sca"
              className="absolute top-0 left-0 w-full h-full border-0"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
              title="Map to our centre"
            />
          </div>
        </div>
      </section>
    </div>
  );
}


